<template>
  <div class="bg_gray">
    <top-header :type="6" :placeholder="'其他监管项目'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner" v-for="(item, index) in list" :key="index">
            <div class="right">
              <h3 class="line_comp1">{{item.xmmc}}</h3>
              <p class="address m_flex_box line_comp1"><span>推广名称：</span><i>{{item.tgmc}}</i></p>
              <p class="address m_flex_box line_comp1"><span>开发企业：</span><i>{{item.cName}}</i></p>
              <p class="address m_flex_box line_comp1"><span>监管项目数：</span><i>{{item.sNum}}</i></p>
              <p class="address m_flex_box line_comp1"><span>监管面积：</span><i>{{item.sMj}} m²</i></p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from "qs";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      bankName:'',
      currPageNo: 1,
      list: [],
      area: this.$route.query.xzqh,
      bankNo: this.$route.query.bankNo,
    };
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {
    onRefresh() {
      this.currPageNo = 1;
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad(1);
    },
    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$new.post('saleSpv/getSaleSpvListByBank.do', qs.stringify({
          currPageNo : this.currPageNo,
          pageSize:10,
          area: this.area,
          bankNo: this.bankNo
        })).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if(res.success) {
            this.list = this.list.concat(res.obj.list)
            this.loading = false;
            this.$set(this, 'currPageNo', this.currPageNo + 1);
          } else {
            this.finished = true;
          }
        })
      }
    },


  },
};
</script>
<style lang="less" scoped>
  .bg_gray{
    background-color: #f4f4f4;
    min-height: 100vh;
  }
  .list{
    .inner{
      background-color: #fff;
      margin-bottom: 0.12rem;
      padding: 0.34rem 0.23rem;
      .right{
        width: 100%;
        h3{
          font-size: 0.34rem;
          font-weight: 600;
          margin-bottom: 0.14rem;
        }
        .address{
          font-size: 0.26rem;
          margin-bottom: 0.08rem;
          color: #202020;
          span{
            color: #909090;
          }
          &.no_mar{
            margin-bottom: 0;
          }
        }
        a{
          color: #2388EC;
          font-size: 0.26rem;
          text-decoration: underline;
        }
      }
    }
  }
</style>